export default "__VITE_ASSET__Diubmbxd__"